(function () {
  if (!document.body.classList.contains('template-index')) return;
  if (window.Shopify && window.Shopify.designMode) return;

  var sections = document.querySelectorAll('#main > .shopify-section');
  var viewportHeight = window.innerHeight;

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.05 });

  sections.forEach(function (el) {
    var rect = el.getBoundingClientRect();
    if (rect.top < viewportHeight) {
      el.classList.add('js-fadein', 'is-visible');
    } else {
      el.classList.add('js-fadein');
      observer.observe(el);
    }
  });
})();
